<template>
  <div class='slide slide-intention'>
    <div class='slide_label body-four-light'>
      {{ activity.label || $t('intentions.intention_setter') }}
    </div>

    <h2 class='slide_headline h-two-light'>
      {{ activity.headline }}
    </h2>

    <div
      v-if='activity.subheadline'
      class='slide_subheadline body-one-light'
    >
      {{ activity.subheadline }}
    </div>

    <button
      class='slide_cta button-one-light'
      @click.prevent='toggleActivityOverlay'
      v-html="has_result ? $t('intentions.view') : $t('intentions.start')"
    />
  </div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  computed: {
    has_result() {
      return this.slide_result.results &&
        this.slide_result.results.current_intention
    }

  }
}
</script>
